module.exports = __webpack_public_path__ + "assets/img/00015.f04fe1c4.png";